import React from 'react'

import { ExpandingCardSet } from 'components/article-elements/card-set/ExpandingCardSet'

import list from './turbo-cube-list.json'

export const TurboCubeList: React.FC = () => {
  return <ExpandingCardSet title="Turbo Cube" columns={list as any} />
}
